type SortableLorebookTarget = {
  character: {
    updatedAt?: number | string;
    createdAt?: number | string;
  };
};

export const getTargetSortTimestamp = (target: SortableLorebookTarget) => {
  const rawTimestamp = target.character.updatedAt ?? target.character.createdAt;
  if (rawTimestamp == null) return 0;
  const parsedTimestamp = new Date(rawTimestamp).getTime();
  return Number.isNaN(parsedTimestamp) ? 0 : parsedTimestamp;
};

export const sortTargetsByUpdatedAtDesc = (targetA: SortableLorebookTarget, targetB: SortableLorebookTarget) =>
  getTargetSortTimestamp(targetB) - getTargetSortTimestamp(targetA);

export const sortTargetsByUpdatedAtAsc = (targetA: SortableLorebookTarget, targetB: SortableLorebookTarget) =>
  getTargetSortTimestamp(targetA) - getTargetSortTimestamp(targetB);
